/**
 * User-facing notices required for FCC-certified IP CTS mode.
 *
 * DRAFT — the exact wording of both notices must be reviewed and approved by
 * TRS counsel before the certified surface is enabled for any tenant. The
 * registered-user prohibition mirrors the FCC's mandated IP CTS notice under
 * 47 CFR § 64.604; do not edit without counsel signoff.
 */
export const IP_CTS_ELIGIBILITY_NOTICE = 'FEDERAL LAW PROHIBITS ANYONE BUT REGISTERED USERS WITH '
    + 'HEARING LOSS FROM USING INTERNET PROTOCOL (IP) CAPTIONED TELEPHONES WITH THE CAPTIONS TURNED ON. '
    + 'IP Captioned Telephone Service may use automated speech recognition to generate captions. '
    + 'The cost of IP CTS is funded through the federal Telecommunications Relay Services Fund.';
export const IP_CTS_EMERGENCY_NOTICE = 'This service is not yet certified for emergency use. '
    + 'Do not rely on it for 911 or other emergency calls until emergency calling is approved and announced.';
